import {analyticsActionType} from '../../constants';


export default (state = {} , action) => {
    switch (action.type) {
        case analyticsActionType.FETCH_ANALYTICS_BY_TODAY:
        case analyticsActionType.FETCH_ANALYTICS_BY_CURRENT_WEEK:
        case analyticsActionType.FETCH_ANALYTICS_BY_LAST_WEEK:
        case analyticsActionType.FETCH_ANALYTICS_BY_CURRENT_MONTH:
        case analyticsActionType.FETCH_ANALYTICS_BY_LAST_MONTH:
        case analyticsActionType.FETCH_ANALYTICS_BETWEEN_MONTHS:
            return action.payload;
        default:
            return state;
    }
};